import { render, staticRenderFns } from "./historicalShipment.vue?vue&type=template&id=ad6c8d74&scoped=true"
import script from "./historicalShipment.vue?vue&type=script&lang=js"
export * from "./historicalShipment.vue?vue&type=script&lang=js"
import style0 from "./historicalShipment.vue?vue&type=style&index=0&id=ad6c8d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6c8d74",
  null
  
)

export default component.exports